/*
Purpose: list details of student with use datatable
Designed by R.Sanjai
Date:24/08/2023 
Project: TCMS


UpdateBy:KTH
updateDate:30/08/2023 
Purpose: include API


UpdateBy:KTH
updateDate:15/12/2025 
Purpose: Modified new tutor time sheet
*/

import { useState, useCallback, useEffect } from "react";
import { useNavigate, useLocation, NavLink } from "react-router-dom";

import { Row, Col, Stack, Dropdown, DropdownButton, ButtonGroup, Modal, Form } from 'react-bootstrap';

import Card from 'react-bootstrap/Card';
import axios from 'axios';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import React from 'react';
import Moment from 'moment';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { options_paymen_frequecy, options_pay_type, security_key, BASE_URL } from "../global";
import { calculateBandedTotal } from "../components/TutorPayBands";
import { timesheetInMonth, timesheetMonthOptions } from "../components/TimesheetPrint";
import PrintTimesheetModal from "../components/PrintTimesheetModal";

import "./add-student.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import Select from "react-select";
import { useFormik } from "formik";
import * as yup from "yup";


function ListTutorTimeSheet() {

  //const [isProfileOverlayOpen, setProfileOverlayOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  
  const [data1, setItems] = useState([]);
  const [records, setRecords] = useState(data1);
  const [tutorData, setTutorData] = useState([]);
  const [Id, setId] = useState(null);

  const [sessionDetails, setSessionDetails] = useState([
    {
      session_key: "",
      session_name: "",
      session_date: "",
      no_of_student: "0"
    },
  ]);

  const initialSetCount = 1; // Set the initial number of sets

  const initialDynamicFields = sessionDetails;
  

  const location = useLocation();
  useEffect(() => {

  const { pk_tut_key } = location.state || {};
  const extractedTId = pk_tut_key;
      if (extractedTId !== '' && extractedTId !== undefined) {
          setId(extractedTId);
          fetchData(extractedTId);
          fetchPayData(extractedTId);
      }else{
        navigate("/list-tutor");
      }
  }, [location]);


  //Api call End
  

  
  const handleTutorClick = () => {
    navigate(`/edit-tutor`, { state: { pk_tut_key: `${Id}` } });
  }


  const [showPaid, setPaidShow] = useState(false);
  const [data_paid, setPaidLabelData] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState(1); //1- paid status 0- unpaid status
  const [isPaidSubmitting, setIsPaidSubmitting] = useState(false);


  const [showPaidDetail, setPaidDetailShow] = useState(false);

  const handlePaidClick = (row, status = 0) => {
   
    const updatedData = { ...row };
    setPaidLabelData(updatedData);
    setPaymentStatus(status);
    setPaidShow(true);
  };

  const handlePaidDetailClick = (row) => {
  
    const updatedData = { ...row };
    setPaidLabelData(updatedData);

    setPaidDetailShow(true);
  };
  const toggleModal = () => setPaidDetailShow(!showPaidDetail);

  // Sample columns configuration
  const columns = [
    {
      headerName: 'S.No',
      field: "id",
      headerClassName: "super-app-theme--header",
      minWidth: 60,
      flex: 0.5,
    },

    {
      headerName: 'Payment Schedule',
      field: "timesheet_frequency",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.timesheet_frequency || '-',
    },

    // {
    //   headerName: 'Period',
    //   field: "period",
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 160,
    //   flex: 1,
    //   valueGetter: (params) => {
    //     const { timesheet_from_date, timesheet_to_date } = params.row || {};
    //     if (!timesheet_from_date || !timesheet_to_date) return '-';
    //     return (
    //       Moment(timesheet_from_date).format('DD-MM-YYYY') +
    //       ' - ' +
    //       Moment(timesheet_to_date).format('DD-MM-YYYY')
    //     );
    //   },
    // },
    {
      headerName: 'From Date',
      field: 'timesheet_from_date',
      headerClassName: 'super-app-theme--header',
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => {
        const from = params?.row?.timesheet_from_date;
        if (!from) return '-';
        return Moment(from).format('DD-MM-YYYY');
      },
    },
  
    {
      headerName: 'To Date',
      field: 'timesheet_to_date',
      headerClassName: 'super-app-theme--header',
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => {
        const to = params?.row?.timesheet_to_date;
        if (!to) return '-';
        return Moment(to).format('DD-MM-YYYY');
      },
    },
    {
      headerName: 'No. of Sessions',
      field: "timesheet_no_of_sessions",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.timesheet_no_of_sessions ?? 0,
    },

    {
      headerName: 'No. of Students',
      field: "timesheet_no_of_students",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.timesheet_no_of_students ?? 0,
    },

    {
      headerName: 'Pay Type Applied',
      field: "timesheet_pay_type",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.timesheet_pay_type == '1' ? "Flat Rate" :
        params?.row?.timesheet_pay_type == '2' ? "Per Session Rate" :
        params?.row?.timesheet_pay_type == '3' ? "Per Student Rate" :
        params?.row?.timesheet_pay_type == '4' ? "Banded Student Rate" : '-',
    },

    {
      headerName: 'Pay Rate',
      field: "timesheet_pay_rate",
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      flex: 1,
      // A banded tutor is paid a different amount per session depending on how many
      // students were in it, so there is no single rate to show here. The breakdown is in
      // the view modal and on the payslip.
      valueGetter: (params) =>
        params?.row?.timesheet_pay_type == '4'
          ? "Banded"
          : params?.row?.timesheet_pay_rate ?? 0,
    },

    {
      headerName: 'Session Type',
      field: "timesheet_session_type",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.timesheet_session_type || '-',
    },

    {
      headerName: 'Adjustment',
      field: "timesheet_adjustment_amount",
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.timesheet_adjustment_amount ?? 0,
    },

    {
      headerName: `Total Amount (${sessionStorage.getItem('currency_code')})`,
      field: "timesheet_total_amount",
      headerClassName: "super-app-theme--header",
      minWidth: 160,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.timesheet_total_amount ?? 0,
    },

    {
      headerName: 'Summary',
      field: "timesheet_summary_json",
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      flex: 1,
      valueGetter: (params) =>
        params?.row?.updated_timesheet_summary_json ? 'View' : '-',
      renderCell: (params) => {
        const row = params.row;
        return row?.updated_timesheet_summary_json ? (
          <div className="gap-2">
          <Button
            variant="outlined-red"
            className="primary-blue my-2"
            onClick={() => handlePaidDetailClick(row)}
          >
            View
          </Button>
           {parseInt(row.timesheet_paid_status) === 1 ? null : <Button
            variant="outlined-red"
            className="primary-blue my-2"
            onClick={() => handleEditClick(row)}
          >
            Edit
          </Button> }
          </div>
        ) : <p>-</p>;
      }

    },

    {
      field: "timesheet_paid_status",
      type: "actions",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      headerAlign: "left",

      valueGetter: (params) =>
        parseInt(params.row.timesheet_paid_status) === 1 ? 'Paid' : 'Unpaid',

      renderCell: (params) => {
        const row = params.row;

        if (!row?.timesheet_total_amount || row.timesheet_total_amount === 0) {
          return <p>-</p>;
        }

        return (
          <>
          <div>
            {
            parseInt(row.timesheet_paid_status) === 1 ?
            <>
              <div className={`text-center text-${parseInt(row.timesheet_paid_status) === 1 ? 'success' : 'danger'}`}>
                {parseInt(row.timesheet_paid_status) === 1 ? 'Paid' :  'Unpaid'}
              </div>
              <div className={`text-danger mt-2`} style={{textDecoration: 'underline'}} 
              onClick={() => {handlePaidClick(row, 0)}} > Change to unpaid</div>
            </>
            :
              <Button
                variant="outlined-red"
                className="primary-blue my-2"
                  onClick={() => handlePaidClick(row, 1)}
                >
                  Set As Paid
                </Button>
            }
            </div>
          </>
        );

      },
    },
    // {
    //       headerName: 'Invoice',
    //       field: "Action",
    //       type: "actions",
    //       headerClassName: "super-app-theme--header",
    //       minWidth: 210,
    //       headerAlign: "left",
    //       renderCell: (params) => {
    //         const row = params.row;
    //         if(row.timesheet_paid_status != 2 && row.timesheet_total_amount > 0){
    //           return (
    //             <div className='d-flex  pad-12'>
    //               <Button variant="outlined-red" onClick={() => downloadInvoiceOfflineCustom(row, 0)} className="primary-blue my-2" >Download </Button>
    //               {row.timesheet_invoice_email_status && row.timesheet_invoice_email_status === "succeeded" ?
    //                 <Button variant="outlined" onClick={() => downloadInvoiceOfflineCustom(row, 1)} className="my-2" 
    //                   style={{
    //                     marginRight: "0.5rem",
    //                     marginTop: "auto",
    //                     marginBottom: "auto",
    //                     backgroundColor: "#28a745", // Green background
    //                     color: "white",
    //                     border: "1px solid #28a745",
    //                     fontSize: "11px",
    //                     textTransform: "none",
    //                     minWidth: "max-content",
    //                     width: "max-content",
    //                     padding: "4px 6px",
    //                   }} >Sent Invoice</Button> 
    //                   :
    //                 <Button variant="outlined-red" onClick={() => downloadInvoiceOfflineCustom(row, 1)} className="primary-blue my-2" >Send Invoice</Button>
    //               }
    //             </div>
    //           );
    //         }else{
    //           return (<div className={`text-${'danger'}`}>-</div>);
    //         }
    //       }
    
    //     },
        {
          headerName: 'Payslip',
          field: "Payslip",
          type: "actions",
          headerClassName: "super-app-theme--header",
          minWidth: 210,
          headerAlign: "left",
          renderCell: (params) => {
            const row = params.row;
            if(row.timesheet_paid_status != 2 && row.timesheet_total_amount > 0){
                return (
                  <div className='d-flex  pad-12'>
                    {parseInt(row.timesheet_paid_status) === 1 ? 
                    <Button variant="outlined-red" onClick={() => downloadReceiptOfflineCustom(row, 0)} className="primary-blue my-2" >Download </Button> 
                    : '-'}
                    {parseInt(row.timesheet_paid_status) === 1 ?  
                        row.timesheet_receipt_email_status && row.timesheet_receipt_email_status === "succeeded" ?
                          <Button variant="outlined" onClick={() => downloadReceiptOfflineCustom(row, 1)} className="my-2" 
                          style={{
                            marginRight: "0.5rem",
                            marginTop: "auto",
                            marginBottom: "auto",
                            backgroundColor: "#28a745", // Green background
                            color: "white",
                            border: "1px solid #28a745",
                            fontSize: "11px",
                            textTransform: "none",
                            minWidth: "max-content",
                            width: "max-content",
                            padding: "4px 6px",
                            }} >Sent Payslip</Button> 
                        :
                          <Button variant="outlined-red" onClick={() => downloadReceiptOfflineCustom(row, 1)} className="primary-blue my-2" >Send Payslip</Button>
                      : ""
                    }
                  </div>
                );
            }else{
                return (<div className={`text-${'danger'}`}>-</div>);
            }
          }
    
        }
  ];


  
  const fetchData = async (id) => {


    try {
      const response = await axios.post(BASE_URL + 'API/api_index.php', {
          security_key: security_key,
          mode: "getSingleTutor_new",
          center_key: sessionStorage.getItem('key'),
          pk_tut_key: id
      });

      if (response.data.success === true) {
          if (response.data.data.length > 0) {
              setTutorData(response.data.data[0]);

          }

          
      } else {
          // Handle unsuccessful response, e.g., show an alert to the user.
      }
  } catch (error) {
      console.error('Error fetching data:', error);
  }
   
  };


  const fetchPayData = async (id) => {
    try {
      const responsetut = await axios.post(BASE_URL + 'API/api_index.php', {
        security_key: security_key,
        mode: "getTutorTimeSheetByTutor",
        center_key: sessionStorage.getItem('key'),
        pk_tut_key: id
      });
    
      if (responsetut.data.success === true) {
        setRecords(responsetut.data.data);
        setItems(responsetut.data.data);
        setLoading(false);

      } else {
        //alert message provide
        setLoading(false);

      }


    } catch (error) {
      console.error('Error fetching data:', error);
    }

  }


  function onSubmitPaid() {
    setIsPaidSubmitting(true);

    const responsepaid = axios.post(BASE_URL + "API/api_index.php", {
      security_key: security_key,
      mode: "paidAndUnpaidTutorTimesheet",
      pk_timesheet_key: data_paid.pk_timesheet_key,
      fk_cent_key: sessionStorage.getItem('key'),
      status: paymentStatus
    }).then((responsepaid) => {

      if (responsepaid.data.data == 1) {

        setPaidShow(false)
        // Handle the successful response here
        toast.success(`Success! The amount has been marked as ${paymentStatus == '1' ? 'Paid' : 'Unpaid'}.`,{
            autoClose: 700,
        });

        fetchPayData(Id);
        setIsPaidSubmitting(false);

      } else {
        toast.error(`Error! Failed to mark the amount as ${paymentStatus == '1' ? 'Paid' : 'Unpaid'}. Please try again.`,{
            autoClose: 700,
        });
        setIsPaidSubmitting(false);
      }
    })
      .catch((error) => {
        // Handle any errors that occurred during the request
        toast.error(`Error! Failed to mark the amount as ${paymentStatus == '1' ? 'Paid' : 'Unpaid'}. Please try again.`,{
            autoClose: 700,
        });
        setIsPaidSubmitting(false);
      });
  }

  // ---- Month filter + Print PDF pop-up ----
  // '' = all months. A timesheet is in a month when its period overlaps it, so a week spanning
  // two months is listed under both. The pop-up opens on this tutor and the grid's month.
  const [selectedMonth, setSelectedMonth] = useState('');
  const [showPrintModal, setShowPrintModal] = useState(false);
  const monthOptions = React.useMemo(() => timesheetMonthOptions(records), [records]);
  const visibleRecords = (records || []).filter((ts) => timesheetInMonth(ts, selectedMonth));

  const summaryList = React.useMemo(() => {
    try {
      return JSON.parse(data_paid?.updated_timesheet_summary_json || '[]');
    } catch (e) {
      return [];
    }
  }, [data_paid]);


  const downloadReceiptOfflineCustom = async (data, type) => {
    try {
      const response = await axios.post(BASE_URL + 'API/api_index.php', {
        invoice_data: data,
        pk_tut_key: Id,
        security_key: security_key,
        mode: 'getDownloadTutorPayslip',
        type: type //1 - receipt sent to mail id , 0 receipt download
      }, {
        responseType: type === 1 ? 'json' : 'blob' , // Ensure response type is blob for binary data (PDF)
      });

      if(type && (Number(type) === 1)){
        if(response && Number(response.data) === 1){
            toast.success(
              "Success! Payslip mail has been successfully sent.",
              {
                autoClose: 700, // 3 seconds in this example
              }
            );
        }else if(response && Number(response.data) === 2){
          toast.error(
            "Failure! The tutor email ID was not found.",
            {
              autoClose: 700, // 3 seconds in this example
            }
          );
        }else if(response && Number(response.data) === 3){
          toast.error(
            "Failure! Centre SMTP In-active.",
            {
              autoClose: 700, // 3 seconds in this example
            }
          );
        }else {
            toast.error(
              "Unable to send the payslip mail.",
              {
                autoClose: 700, // 3 seconds in this example
              }
            );
        }
        fetchPayData(Id);
      }else{

        // Create a blob object from the PDF Blob data received
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link element
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `PS_00${data.pk_timesheet_id}.pdf`;

        // Append the link to the body and click it to trigger download
        document.body.appendChild(a);
        a.click();

        // Clean up: remove the temporary link and URL object
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }

    } catch (error) {
      console.error('Error downloading invoice:', error);
    }
  };


  const calculateTotalAmount = (
    timesheet_pay_type,
    pay_rate,
    arraySession = []
  ) => {
    if (!timesheet_pay_type || !Array.isArray(arraySession)) return 0;
    const payType = Number(timesheet_pay_type);
    const flat_rate = Number(pay_rate) || 0;
    const per_session_rate = Number(pay_rate) || 0;
    const per_student_rate = Number(pay_rate) || 0;

    const sessionCount = arraySession.length;
    const studentCount = arraySession.reduce(
      (sum, item) => sum + (Number(item.no_of_student) || 0),
      0
    );
    console.log(flat_rate);

    /*
    * Pay Type Formula:
    * 1 → Flat Rate
    * 2 → No Of Session × Per Session Rate
    * 3 → No Of Students (summed across sessions) × Per Student Rate
    * 4 → Sum over lessons of the band amount for that lesson's student count
    */

    switch (payType) {
      case 1: // Flat rate
        return flat_rate;

      case 2: // Per session
        return sessionCount * per_session_rate;

      case 3: // Per student
        return studentCount * per_student_rate;

      case 4: // Banded student rate
        // Pay types 1-3 are linear, so the totals above price them. This one is not:
        // each lesson pays the band matching its own headcount, at the rates that were
        // in force on the day it was taught.
        return calculateBandedTotal(tutorData?.pay_config_versions, arraySession);

      default:
        return 0;
    }
  };


  // add popup start
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAddTimesheet, setAddTimesheet] = useState(false);
  const toggleModalAddTimesheet = () => setAddTimesheet(!showAddTimesheet);


  const getMonthlyRangeFromLastDate = (lastToDate) => {
    if (!lastToDate) return { from: "", to: "" };

    const from = Moment(lastToDate)
      .add(1, "day")
      .format("YYYY-MM-DD");

    const to = Moment(from)
      .add(1, "month")
      .subtract(1, "day")
      .format("YYYY-MM-DD");

    return { from, to };
  };

  const getWeeklyRangeFromLastDate = (lastToDate) => {
    if (!lastToDate) return { from: "", to: "" };

    const from = Moment(lastToDate)
      .add(1, "day")
      .format("YYYY-MM-DD");

    const to = Moment(from)
      .add(6, "days")
      .format("YYYY-MM-DD");

    return { from, to };
  };


  const basicSchema = yup.object().shape({

    timesheet_frequency: yup.mixed().required("Frequency is required."),
    timesheet_from_date: yup
      .string()
      .nullable(true)
      .test("is-valid-date", "Please provide a valid date.", function (value) {
        // Check if the value is null or a valid date

        return (
          value === undefined ||
          value === null ||
          value === "" ||
          dayjs(value, "YYYY-MM-DD").isValid()
        );
      }),
    timesheet_to_date: yup
    .string()
    .nullable(true)
    .test("is-valid-date", "Please provide a valid date.", function (value) {
      // Check if the value is null or a valid date

      return (
        value === undefined ||
        value === null ||
        value === "" ||
        dayjs(value, "YYYY-MM-DD").isValid()
      );
    }),

    tut_pay_type: yup.mixed().required("Pay type is required."),
    timesheet_pay_rate: yup.number().required("Pay Rate is required."),
    
    // timesheet_adjustment_amount: yup
    //   .number()
    //   .typeError("Enter a valid number")
    //   .min(0, "Minimum value 0 required")
    //   .max(1000, "Maximum value exceeded") 
    //   .required("Flat Rate Fee is required."),
    dynamicFields: yup.array().of(
      yup.object().shape({
        session_name: yup.string().required("Name is required"),
        session_date: yup
          .string()
          .test(
            "is-valid-date",
            "Please provide a valid date.",
            function (value) {
              const parsedDate = dayjs(value, "YYYY-MM-DD");
              return parsedDate.isValid();
            }
          )
          .required("Date is required"),
        no_of_student: yup
          .number()
          .typeError("Only numbers are allowed")
          .min(1, "Minimum value is 1")
          .max(500, "Maximum value is 500")
          .required("Value is required"),
      })
    ),
    timesheet_note: yup
      .string()
      .min(2, "Minimum 2 characters is required.")
      .max(250, "Maximum 250 characters is required.")
      .notRequired()
      .matches(
        /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
        "Avoid start & end with a space or comma"
      ),
      timesheet_adjustment_amount: yup.number()
    .typeError("Adjustment must be a number")
    .min(0, "Adjustment cannot be negative")
    .test(
      "max-adjustment",
      "Maximum value exceeded",
      function (value) {
        const { tut_pay_type, timesheet_pay_rate, dynamicFields } = this.parent;
         console.log("test")
          console.log(tut_pay_type)
           console.log(timesheet_pay_rate)
            console.log(dynamicFields)
        const maxAmount = calculateTotalAmount(
          tut_pay_type,
          timesheet_pay_rate,
          dynamicFields
        );
        console.log(maxAmount);
        return value <= maxAmount;
      }
    ),
  });

  const initialValues = {
    pk_tutor_key: tutorData ? tutorData.pk_tut_key : "",
    timesheet_frequency: "",
    timesheet_from_date: "",
    timesheet_to_date: "",
    tut_pay_type: tutorData?.tut_pay_type || '',
    timesheet_session_type: tutorData?.timesheet_session_type || '',
    timesheet_adjustment_amount: 0,
    // Pay type 4 has a rate per headcount rather than a single rate, so it leaves this at
    // 0 and prices each lesson from the bands instead.
    timesheet_pay_rate: tutorData?.tut_pay_type == '1'? tutorData?.tut_flat_rate :
      tutorData?.tut_pay_type == '2'? tutorData?.tut_per_ses_rate :
      tutorData?.tut_pay_type == '3'? tutorData?.tut_per_stu_rate : 0,
    timesheet_note: '',
    dynamicFields: initialDynamicFields,
    fk_cent_key: sessionStorage.getItem("key"),
  };
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: basicSchema,
    // onSubmit,
    onSubmit: async (formValues) => {
      setIsSubmitting(true);

      try {
        const response = await axios.post(BASE_URL + "API/api_index.php", {
          security_key: security_key,
          mode: "addTutorTimesheet",
          ...formValues,
        });

        if (response.data.success === true) {
          // Reset the form
          //formRef.current.reset();
          if (response.data.data === 1) {
            toast.success("Timesheet added successfully", {
              autoClose: 700, // 3 seconds in this example
            });
            fetchPayData(Id);
            setAddTimesheet(false);
            formik.resetForm();
            formik.setFieldValue("timesheet_frequency", "");
            formik.setFieldValue("timesheet_frequency", tutorData.tut_payment_frequency);
          }  else {
            toast.error(
              "Failure! Unable to added tutor timesheet. Try again later",
              {
                autoClose: 700, // 3 seconds in this example
              }
            );

            setIsSubmitting(false); // Re-enable the submit button
          }
        } else {
          toast.error(
            "Failure! Unable to added tutor timesheet. Try again later",
            {
              autoClose: 700, // 3 seconds in this example
            }
          );

          setIsSubmitting(false); // Re-enable the submit button
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error(
          "Failure! Unable to added tutor timesheet. Try again later",
          {
            autoClose: 700, // 3 seconds in this example
          }
        );

        setIsSubmitting(false); // Re-enable the submit button
      } finally {
        setIsSubmitting(false); // Re-enable the submit button
      }
    },
  });

  // Now, you can set variables as needed:
  const values = formik.values;
  const handleBlur = formik.handleBlur;
  const touched = formik.touched;
  const handleChange = formik.handleChange;
  const errors = formik.errors;
  const handleSubmit = formik.handleSubmit;
  const setTouched = formik.setTouched;
  const resetForm = formik.resetForm;
  const setValues = formik.setValues;
  const handleReset = formik.handleReset;

  useEffect(() => {
  if (formik.values.tut_pay_type) {
    formik.setFieldTouched("timesheet_adjustment_amount", true, false);
    formik.validateField("timesheet_adjustment_amount");
  }
}, [
  formik.values.tut_pay_type,
  formik.values.timesheet_pay_rate,
  formik.values.dynamicFields
]);


  const handleAddInput = () => {
    formik.setFieldValue("dynamicFields", [
      ...formik.values.dynamicFields,
      { session_key: "", session_name: "", session_date: "", no_of_student: "0", },
    ]);
  };

  const handleRemoveInput = (index) => {
    const dynamicFields = [...formik.values.dynamicFields];

    if (dynamicFields.length !== initialSetCount) {
      dynamicFields.splice(index, 1);
      formik.setFieldValue("dynamicFields", dynamicFields);
    }
  };

   
  //add popup end

  
  //edit popup start
  const [isEditSubmitting, setIsEditSubmitting] = useState(false);
  const [showEditTimesheet, setEditTimesheet] = useState(false);
  const toggleModalEditTimesheet = () => setEditTimesheet(!showEditTimesheet);
  const [showEditData, setEditData] = useState(null);
  
  const basicSchemaEdit = yup.object().shape({

    tut_pay_type: yup.mixed().required("Pay type is required."),
    timesheet_pay_rate: yup.number().required("Pay Rate is required."),
    timesheet_adjustment_amount: yup.number()
    .typeError("Adjustment must be a number")
    .min(0, "Adjustment cannot be negative")
    .test(
      "max-adjustment",
      "Maximum value exceeded",
      function (value) {
        const { tut_pay_type, timesheet_pay_rate, dynamicFields } = this.parent;

        const maxAmount = calculateTotalAmount(
          tut_pay_type,
          timesheet_pay_rate,
          dynamicFields
        );
        console.log(maxAmount);
        return value <= maxAmount;
      }
    ),
    timesheet_adjustment_amount: yup
      .number()
      .typeError("Enter a valid number")
      .min(0, "Minimum value 0 required")
      .max(1000, "Maximum value exceeded") 
      .required("Flat Rate Fee is required."),
    dynamicFields: yup.array().of(
      yup.object().shape({
        session_name: yup.string().required("Name is required"),
        session_date: yup
          .string()
          .test(
            "is-valid-date",
            "Please provide a valid date.",
            function (value) {
              const parsedDate = dayjs(value, "YYYY-MM-DD");
              return parsedDate.isValid();
            }
          )
          .required("Date is required"),
        no_of_student: yup
          .number()
          .typeError("Only numbers are allowed")
          .min(1, "Minimum value is 1")
          .max(500, "Maximum value is 500")
          .required("Value is required"),
      })
    ),
    timesheet_note: yup
      .string()
      .min(2, "Minimum 2 characters is required.")
      .max(250, "Maximum 250 characters is required.")
      .notRequired()
      .matches(
        /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
        "Avoid start & end with a space or comma"
      ),
  });

  const initialValuesEdit = {
    pk_timesheet_key: showEditData?.pk_timesheet_key || "",
    timesheet_frequency: showEditData?.timesheet_frequency || "",
    timesheet_from_date: showEditData?.timesheet_from_date || "",
    timesheet_to_date: showEditData?.timesheet_to_date || "",
    tut_pay_type: showEditData?.timesheet_pay_type || '',
    timesheet_session_type: showEditData?.timesheet_session_type || '',
    timesheet_adjustment_amount: showEditData?.timesheet_adjustment_amount || 0,
    timesheet_pay_rate: showEditData?.timesheet_pay_rate || 0,
    timesheet_note: showEditData?.timesheet_note || '',
    dynamicFields: initialDynamicFields,
    fk_cent_key: sessionStorage.getItem("key"),
  };
  const formikEdit = useFormik({
    initialValues: initialValuesEdit,
    validationSchema: basicSchemaEdit,
    enableReinitialize: true,
    // onSubmit,
    onSubmit: async (formValues) => {
      setIsEditSubmitting(true);

      try {
        const response = await axios.post(BASE_URL + "API/api_index.php", {
          security_key: security_key,
          mode: "editTutorTimesheet",
          ...formValues,
        });

        if (response.data.success === true) {
          // Reset the form
          //formRef.current.reset();
          if (response.data.data === 1) {
            toast.success("Timesheet Updated successfully", {
              autoClose: 700, // 3 seconds in this example
            });

           setIsEditSubmitting(false);
           fetchPayData(Id);
            setEditTimesheet(false);
            setEditData(null);
          }  else {
            toast.error(
              "Failure! Unable to update tutor timesheet. Try again later",
              {
                autoClose: 700, // 3 seconds in this example
              }
            );

            setIsEditSubmitting(false); // Re-enable the submit button
          }
        } else {
          toast.error(
            "Failure! Unable to update tutor timesheet. Try again later",
            {
              autoClose: 700, // 3 seconds in this example
            }
          );

          setIsEditSubmitting(false); // Re-enable the submit button
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error(
          "Failure! Unable to update tutor timesheet. Try again later",
          {
            autoClose: 700, // 3 seconds in this example
          }
        );

        setIsEditSubmitting(false); // Re-enable the submit button
      } finally {
        setIsEditSubmitting(false); // Re-enable the submit button
      }
    },
  });

  const handleEditClick = (row) => {
    const updatedData = { ...row };
    const summary = JSON.parse(row?.updated_timesheet_summary_json || '[]');
      
        if (summary.length > 0) {
          const formattedData = summary.map((item) => ({
            session_key: item?.session_key || '',
            session_name: item?.session_name || '',
            session_date: item?.session_date || '',
            no_of_student: item?.no_of_students || '0',
          }));
          setSessionDetails(formattedData);
          // handleOption();
        } else {
          setSessionDetails([
             {
              session_key: "",
              session_name: "",
              session_date: "",
              no_of_student: "0"
            }
          ]);
        }
    setEditData(updatedData);
    formikEdit.setFieldValue("tut_pay_type", row?.timesheet_pay_type || "");
    setEditTimesheet(true);
  };

  const handleAddInputEdit = () => {
    formikEdit.setFieldValue("dynamicFields", [
      ...formikEdit.values.dynamicFields,
      { session_key: "", session_name: "", session_date: "", no_of_student: "0", },
    ]);
  };

  const handleRemoveInputEdit = (index) => {
    const dynamicFields = [...formikEdit.values.dynamicFields];

    if (dynamicFields.length !== initialSetCount) {
      dynamicFields.splice(index, 1);
      formikEdit.setFieldValue("dynamicFields", dynamicFields);
    }
  };


  //edit popup end



  return (
    <>
    <ToastContainer position="top-center" />
    <div className="page-wrapper">

      <Modal show={showPaid} variant="danger">

        <Modal.Header>Paid</Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to mark this as {paymentStatus == '1' ? 'Paid' : 'Unpaid'}? </p>

        </Modal.Body>
        <Modal.Footer className='pt-0'>
          <div className="mx-auto d-flex gap-2" >

            <Button variant="contained" className="primary-gray" onClick={() => setPaidShow(false)}>Cancel</Button>
            <Button variant="contained" type='submit' className="primary-filled " disabled={isPaidSubmitting} onClick={() => onSubmitPaid()} >Yes</Button>
          </div>

        </Modal.Footer>

      </Modal>

      {/* Summary Details */}
      <Modal show={showPaidDetail} size="lg" onHide={toggleModal} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton> 
        <Modal.Title>
          <h5 className='page-title'>  Summary </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bdr-btm">
        <Row>
          <Col lg="6" md="6" sm="6" className='position-relative'>
            <Card className='rounded-1 mt-2 card-bdr' >
              <Card.Body>
                <div className="me-2">
                  <div className="">

                    <div className="cus-pyt-dtls">
                      <h6 className='mb-0'>Tutor Name:</h6>
                      <p className="mb-0">
                      {tutorData ? tutorData.tut_fname != null && tutorData.tut_fname != '' ? tutorData.tut_fname + ' ' + tutorData.tut_surname  : '' : ''}
                      </p>
                    </div>

                    <div className="cus-pyt-dtls">
                      <h6 className='mb-0'>Frequency:</h6>
                      <p className="mb-0">
                        {data_paid.timesheet_frequency}
                      </p>
                    </div>
                    <div className="cus-pyt-dtls">
                      <h6 className='mb-0'>Pay Type:</h6>
                      <p className="mb-0">
                        {data_paid.timesheet_pay_type == '1' ? "Flat Rate" :
                        data_paid.timesheet_pay_type == '2' ? "Per Session Rate" :
                        data_paid.timesheet_pay_type == '3' ? "Per Student Rate" :
                        data_paid.timesheet_pay_type == '4' ? "Banded Student Rate" : '-'}
                      </p>
                    </div>
                    <div className="cus-pyt-dtls">
                      <h6 className='mb-0'>Pay Rate Applied:</h6>
                      <p className="mb-0">
                        {/* A banded tutor has no single rate -- the per-session breakdown below carries them. */}
                        {data_paid.timesheet_pay_type == '4'
                          ? "Banded"
                          : `${data_paid.timesheet_pay_rate} - ${sessionStorage.getItem('currency_code')}`}
                      </p>
                    </div>
                    <div className="cus-pyt-dtls">
                      <h6 className='mb-0'>Adjustment:</h6>
                      <p className="mb-0">
                        {data_paid.timesheet_adjustment_amount} - {sessionStorage.getItem('currency_code')}
                      </p>
                    </div>

                    
                      
                        

                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg="6" md="6" sm="6" className='position-relative'>
            <Card className='rounded-1 mt-2 card-bdr' >
              <Card.Body>
                <div className="me-2">
                  <div className="">
                    <div className="cus-pyt-dtls">
                      <h6>From Date:</h6>
                        <p className="mb-0">
                          {Moment(data_paid.timesheet_from_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}
                        </p>
                    </div>

                    <div className="cus-pyt-dtls">
                        <h6>End Date:</h6>
                        <p className="mb-0">
                          {Moment(data_paid.timesheet_to_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}
                        </p>
                    </div>
                    
                    <div className="cus-pyt-dtls">
                        <h6>Amount:</h6>
                        <p className="mb-0">
                          {data_paid.timesheet_total_amount} - {sessionStorage.getItem('currency_code')}
                        </p>
                    </div>

                    <div className="cus-pyt-dtls mb-0">
                        <h6 className="mb-0">Status:</h6>
                        {data_paid.timesheet_paid_status == '1' ?
                        <p className="mb-0 text-success"> <strong>Paid</strong> </p>
                        :  <p className="mb-0 text-danger"> <strong>Unpaid</strong> </p>}
                          
                    </div>
                    <div className="cus-pyt-dtls mt-2">
                        <h6>Paid Date:</h6>
                        <p className="mb-0">
                          { data_paid?.timesheet_paid_date ? Moment(data_paid.timesheet_paid_date).format('DD-MM-YYYY') : "-"}
                        </p>
                    </div>
                        

                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
            <Col lg="12" md="12" sm="12" className='position-relative'>
            <Card className='rounded-1 mt-2 card-bdr' >
              <Card.Body>
                <div className="me-2">
                  {/* session Details */}
                  <Stack className="">
                    <div className="my-card p-4 bg-white">
                      <div className="section-heading border-bottom pb-3 mb-3">
                        <h6 className="mb-0">Session Details </h6>
                      </div>

                      <div className="cus-pyt-dtls">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th style={{ width: '10%' }}>S.No</th>
                              <th style={{ width: '30%' }}>Date</th>
                              <th style={{ width: '40%' }}>Name</th>
                              <th style={{ width: '20%' }}>No. of Students</th>
                              {/* A banded tutor is paid per session according to how many students
                                  were in it. The band that applied was recorded when the timesheet
                                  was generated, so it stays correct even if the rates change later. */}
                              {data_paid?.timesheet_pay_type == '4' && (
                                <>
                                  <th style={{ width: '15%' }}>Band</th>
                                  <th style={{ width: '20%' }}>Amount</th>
                                </>
                              )}
                            </tr>
                          </thead>

                          <tbody>
                            {summaryList.length > 0 ? (
                              summaryList.map((item, index) => (
                                <tr key={index}>
                                  <td>{(index + 1)}</td>
                                  <td>{Moment(item.session_date).format('DD-MM-YYYY') || '-'}</td>
                                  <td>{item.session_name || '-'}</td>
                                  <td>{item.no_of_students ?? 0}</td>
                                  {data_paid?.timesheet_pay_type == '4' && (
                                    <>
                                      <td>{item.band_label || '-'}</td>
                                      <td>{Number(item.band_amount ?? 0).toFixed(2)}</td>
                                    </>
                                  )}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="cus-pyt-dtls">
                        <div className="d-flex w-100" >
                          <h6 >
                            Applied Formula {['top'].map((placement) => (
                              <OverlayTrigger
                                key={placement}
                                placement={placement}
                                overlay={
                                  <Tooltip id={`tooltip-${placement}`} className="custom-tooltip">
                                    <div style={{ textAlign: 'initial' }}>
                                      <div>
                                        The tutor’s payment is calculated from the pay type, as follows:
                                        <br></br>
                                        1. Flat Rate: Flat Rate only <br></br>
                                        2. Per session rate: No of sessions * Pay Rate(Per session rate) <br></br>
                                        3. Per student rate: No of students * Pay Rate(Per student rate)  <br></br>
                                        4. Banded student rate: each session pays the band matching the number of students in it <br></br>
                                      </div>
                                    </div>
                                  </Tooltip>
                                }
                              >
                                <Button variant="secondary" className="no-bdr justify-content-start align-items-start">
                                  <i class="fa-solid fa-info-circle ml-2 mr-2 mt-1"></i>
                                </Button>
                              </OverlayTrigger>

                            ))}
                          </h6> 
                        </div>
                        {/* Formula Line */}
                        <p className="mb-1 ms-2 w-100">
                          {data_paid?.timesheet_pay_type == '1' && (
                            <>
                              Flat Rate {'=>'} <b>{data_paid.timesheet_pay_rate}</b>
                            </>
                          )}

                          {data_paid?.timesheet_pay_type == '2' && (
                            <>
                              Per Session  {'=>'} ({summaryList.length}) × {data_paid.timesheet_pay_rate}
                              {" = "}
                              <b>{summaryList.length * data_paid.timesheet_pay_rate}</b>
                            </>
                          )}

                          {data_paid?.timesheet_pay_type == '3' && (
                            <>
                              Per Student {'=>'} (
                              {summaryList.reduce(
                                (sum, item) => sum + (Number(item.no_of_students) || 0),
                                0
                              )}
                              ) × {data_paid.timesheet_pay_rate}
                              {" = "}
                              {/* Students x rate. The student count is already summed across
                                  sessions, so it is not multiplied by the session count again. */}
                              <b>
                                {(
                                  (Number(data_paid.timesheet_pay_rate) || 0) *
                                  summaryList.reduce(
                                    (sum, item) => sum + (Number(item.no_of_students) || 0),
                                    0
                                  )
                                ).toFixed(2)}
                              </b>
                            </>
                          )}

                          {/* Each session pays its own band, so the sum is the breakdown in the
                              table above rather than a single expression. */}
                          {data_paid?.timesheet_pay_type == '4' && (
                            <>
                              Banded Student Rate {'=>'} sum of each session’s band amount
                              {" = "}
                              <b>
                                {summaryList
                                  .reduce((sum, item) => sum + (Number(item.band_amount) || 0), 0)
                                  .toFixed(2)}
                              </b>
                            </>
                          )}
                        </p>

                        {/* Adjustment Line */}
                        {Number(data_paid?.timesheet_adjustment_amount) !== 0 && (
                          <p className="mb-1 text-muted w-100">
                            Adjustment ({data_paid.timesheet_adjustment_amount > 0 ? "-" : ""}
                            {data_paid.timesheet_adjustment_amount})
                          </p>
                        )}

                        {/* Final Amount */}
                        <p className="mb-0 fw-bold ms-2 w-100">
                          Final Amount = {data_paid?.timesheet_total_amount} - {sessionStorage.getItem('currency_code')}
                        </p>
                      </div>

                    </div>
                  </Stack>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className=''>
        <div className="mx-auto d-flex gap-2" >

          <Button variant="contained" className="primary-gray" onClick={() => setPaidDetailShow(false)}>Cancel</Button>
        
        </div>

      </Modal.Footer>

      </Modal>

      
      {/* add timesheet Details */}
      <Modal show={showAddTimesheet} size="lg" onHide={toggleModalAddTimesheet} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton> 
          <Modal.Title>
            <h5 className='page-title'> Timesheet </h5>
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Body className="bdr-btm">
            
              <div className="my-card p-4 bg-white">
                <Row>
                  
                  <Col lg="4" md="6" sm="12" className="position-relative">
                    <h6 className="form-lable required-field">
                      Frequency
                    </h6>
                    <Select
                      menuPlacement="auto"
                      options={options_paymen_frequecy}
                      name="timesheet_frequency"
                      id="timesheet_frequency"
                      value={options_paymen_frequecy.find(
                        (option) => option.value == values.timesheet_frequency
                      )}
                      onChange={(selectedOption) => {
                        const event = {
                          target: {
                            name: "timesheet_frequency",
                            value: selectedOption["value"],
                          },
                        };
                        handleChange(event);
                        if (selectedOption["value"] === "Weekly") {
                          // const nextDate = data1?.[0]?.timesheet_to_date
                          //   ? new Date(new Date(data1[0].timesheet_to_date).setDate(
                          //       new Date(data1[0].timesheet_to_date).getDate() + 1
                          //     )).toISOString().split("T")[0]
                          //   : "";
                          const tutor_start_date = data1?.[0]?.timesheet_to_date || tutorData?.te_st_date || '';
                          //const dates = getWeeklyDates(tutor_start_date);
                          const dates = getWeeklyRangeFromLastDate(
                              tutor_start_date
                            );
                          formik.setFieldValue("timesheet_from_date", dates.from);
                          formik.setFieldValue("timesheet_to_date", dates.to);
                        }

                        if (selectedOption["value"] === "Monthly") {
                          // const nextDate = data1?.[0]?.timesheet_to_date
                          //   ? new Date(new Date(data1[0].timesheet_to_date).setDate(
                          //       new Date(data1[0].timesheet_to_date).getDate() + 1
                          //     )).toISOString().split("T")[0]
                          //   : "";
                          const tutor_start_date = data1?.[0]?.timesheet_to_date || tutorData?.te_st_date || '';
                          const dates = getMonthlyRangeFromLastDate(
                              tutor_start_date
                            );
                          formik.setFieldValue("timesheet_from_date", dates.from);
                          formik.setFieldValue("timesheet_to_date", dates.to);
                        }
                      }}
                      onBlur={(event) => {
                        handleBlur(event);
                        setTouched({ ...touched, timesheet_frequency: true });
                      }}
                      className={
                        errors.timesheet_frequency &&
                        touched.timesheet_frequency
                          ? "input-error"
                          : ""
                      }
                    />
                    {errors.timesheet_frequency &&
                      touched.timesheet_frequency && (
                        <span className="error">
                          {errors.timesheet_frequency}
                        </span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                      <h6 className="form-lable required-field">From Date</h6>
                      <Form.Control
                        type="text"
                        name={`timesheet_from_date`}
                        value={values.timesheet_from_date}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id={`timesheet_from_date`}
                        className={
                          errors.timesheet_from_date &&
                          touched.timesheet_from_date
                            ? "input-error"
                            : ""
                        }
                        disabled={true}
                        />
                      {errors.timesheet_from_date && touched.timesheet_from_date && (
                        <span className="error">{errors.timesheet_from_date}</span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                      <h6 className="form-lable required-field">To Date</h6>
                      <Form.Control
                        type="text"
                        name={`timesheet_to_date`}
                        value={values.timesheet_to_date}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id={`timesheet_to_date`}
                        className={
                          errors.timesheet_to_date &&
                          touched.timesheet_to_date
                            ? "input-error"
                            : ""
                        }
                        disabled={true}
                        />
                      {errors.timesheet_to_date && touched.timesheet_to_date && (
                        <span className="error">{errors.timesheet_to_date}</span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                      <h6 className="form-lable required-field">Pay Type</h6>
                      <Select
                        menuPlacement="auto"
                        options={options_pay_type}
                        name="tut_pay_type"
                        id="tut_pay_type"
                        value={options_pay_type.find(
                          (option) => option.value == values.tut_pay_type
                        )}
                        onChange={(selectedOption) => {
                          const event = {
                            target: {
                              name: "tut_pay_type",
                              value: selectedOption["value"],
                            },
                          };
                          handleChange(event);
                          let rate = 0;
                          if(selectedOption["value"] == '1'){
                            rate = tutorData?.tut_flat_rate || 0;
                          }else if(selectedOption["value"] == '2'){
                            rate = tutorData?.tut_per_ses_rate || 0;
                          }else if(selectedOption["value"] == '3'){
                            rate = tutorData?.tut_per_stu_rate || 0;
                          }
                          formik.setFieldValue("timesheet_pay_rate", rate);
                        }}
                        onBlur={(event) => {
                          handleBlur(event);
                          setTouched({ ...touched, tut_pay_type: true });
                        }}
                        className={
                          errors.tut_pay_type && touched.tut_pay_type
                            ? "input-error"
                            : ""
                        }
                      />
                      {errors.tut_pay_type && touched.tut_pay_type && (
                        <span className="error">{errors.tut_pay_type}</span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                    <h6 className="form-lable required-field">Pay Rate</h6>
                    {/* A banded tutor has a rate per headcount rather than one rate, so each
                        session below is priced from its own band as you enter the students. */}
                    {String(values.tut_pay_type) === "4" ? (
                      <Form.Control type="text" value="Banded" disabled={true} readOnly />
                    ) : (
                      <>
                        <Form.Control
                          type="number"
                          id="timesheet_pay_rate"
                          step="0.01"
                          min="0"          // minimum allowed value
                          value={values.timesheet_pay_rate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={
                            errors.timesheet_pay_rate && touched.timesheet_pay_rate
                              ? "input-error"
                              : ""
                          }
                          disabled={true}
                        />
                        {errors.timesheet_pay_rate && touched.timesheet_pay_rate && (
                          <p className="error">{errors.timesheet_pay_rate}</p>
                        )}
                      </>
                    )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                    <h6 className="form-lable required-field">Adjustment</h6>
                    <Form.Control
                      type="number"
                      id="timesheet_adjustment_amount"
                      step="0.01"
                      min="0"          // minimum allowed value
                      value={values.timesheet_adjustment_amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.timesheet_adjustment_amount && touched.timesheet_adjustment_amount
                          ? "input-error"
                          : ""
                      }
                    />
                    {errors.timesheet_adjustment_amount && touched.timesheet_adjustment_amount && (
                      <p className="error">{errors.timesheet_adjustment_amount}</p>
                    )}
                  </Col>
                  <Col lg="12" md="12" sm="12" className="position-relative">
                    <h6 className="form-lable">Note</h6>
                    
                    <Form.Control as="textarea" rows={3}
                        value={values.timesheet_note}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        id="timesheet_note"
                        className={errors.timesheet_note && touched.timesheet_note ? "input-error control_textarea" : "control_textarea mb-0"}
                    />
                    {errors.timesheet_note && touched.timesheet_note && (
                      <p className="error">{errors.timesheet_note}</p>
                    )}
                  </Col>
                  <div className="mt-3">
                    {
                      <h6>
                        Total Amount : 
                        {(calculateTotalAmount(values.tut_pay_type, 
                        values.timesheet_pay_rate, 
                        formik.values.dynamicFields) - values.timesheet_adjustment_amount) }
                      </h6>
                    }
                  </div>
                </Row>
              </div>
            
            {/* session Details */}
              <Stack className="mt-4">
                <div className="my-card p-4 bg-white">
                  <div className="section-heading border-bottom pb-3 mb-3">
                    <h6 className="mb-0">Session Details </h6>
                  </div>

                  {/* Dynamic Fields */}
                  {formik.values.dynamicFields.map((field, index) => (
                    <div key={index}>
                      <Row>
                        <Col lg="3" md="6" sm="12" className="position-relative">
                          <h6 className="form-lable required-field">Date</h6>
                          <LocalizationProvider
                            className={"form-control"}
                            dateAdapter={AdapterDayjs}
                          >
                            <DatePicker
                              views={["year", "month", "day"]}
                              value={dayjs(field.session_date, "YYYY-MM-DD")}
                              onChange={(date) => {
                                const event = {
                                  target: {
                                    name: `dynamicFields[${index}].session_date`,
                                    value:
                                      date != null
                                        ? dayjs(date, "YYYY-MM-DD").format(
                                            "YYYY-MM-DD"
                                          )
                                        : date,
                                  },
                                };
                                formik.handleChange(event);
                              }}
                              onBlur={(event) => {
                                formik.handleBlur(event);
                                //formik.setTouched({ ...touched, ls_date: true });
                              }}
                              name={`dynamicFields[${index}].session_date`}
                              slotProps={{
                                textField: {
                                  readOnly: true,
                                  size: "small",
                                  id: `dynamicFields[${index}].session_date`,
                                },
                              }}
                              className={
                                formik.errors.dynamicFields &&
                                formik.errors.dynamicFields[index]?.session_date &&
                                formik.touched.dynamicFields &&
                                formik.touched.dynamicFields[index]?.session_date
                                  ? "input-error w-100"
                                  : "w-100"
                              }
                              minDate={dayjs().subtract(1, 'year')}
                              maxDate={dayjs().add(1, 'year')}
                              format="DD-MM-YYYY"
                            />
                          </LocalizationProvider>
                          {formik.errors.dynamicFields &&
                            formik.errors.dynamicFields[index]?.session_date &&
                            formik.touched.dynamicFields &&
                            formik.touched.dynamicFields[index]?.session_date && (
                              <span className="error">
                                {formik.errors.dynamicFields[index].session_date}
                              </span>
                            )}
                        </Col>
                        <Col lg="5" md="6" sm="12" className='position-relative'>
                          <h6 className="form-lable required-field">Name</h6>
                          <Form.Control
                          type="text"
                          name={`dynamicFields[${index}].session_name`}
                          value={field.session_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id={`dynamicFields[${index}].session_name`}
                          className={formik.errors.dynamicFields && formik.errors.dynamicFields[index]?.session_name && formik.touched.dynamicFields && formik.touched.dynamicFields[index]?.session_name ? "input-error" : ""}
                          />
                          {formik.errors.dynamicFields && formik.errors.dynamicFields[index]?.session_name && formik.touched.dynamicFields && formik.touched.dynamicFields[index]?.session_name && <p className="error">{formik.errors.dynamicFields[index].session_name}</p>}
                        </Col> 
                      
                        <Col lg="3" md="6" sm="12" className="position-relative">
                          <h6 className="form-lable required-field">No Of Student</h6>
                          <Form.Control
                            type="text"
                            name={`dynamicFields[${index}].no_of_student`}
                            value={field.no_of_student}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id={`dynamicFields[${index}].no_of_student`}
                            className={
                              formik.errors.dynamicFields &&
                              formik.errors.dynamicFields[index]?.no_of_student &&
                              formik.touched.dynamicFields &&
                              formik.touched.dynamicFields[index]?.no_of_student
                                ? "input-error"
                                : ""
                            }
                          />
                          {formik.errors.dynamicFields &&
                            formik.errors.dynamicFields[index]?.no_of_student &&
                            formik.touched.dynamicFields &&
                            formik.touched.dynamicFields[index]?.no_of_student && (
                              <p className="error">
                                {formik.errors.dynamicFields[index].no_of_student}
                              </p>
                            )}
                        </Col>

                        <Col
                          lg="1"
                          md="1"
                          sm="1"
                          className="position-relative mt-4"
                        >
                          <Button
                            type="button"
                            variant="outlined-red"
                            className="filled-danger my-2"
                            style={{
                              display:
                                formik.values.dynamicFields.length == 1
                                  ? "none"
                                  : "block",
                            }}
                            onClick={() => handleRemoveInput(index)}
                          >
                            Delete
                          </Button>

                          {/* <button type="button" onClick={() => handleRemoveInput(index)}>
                        Remove
                        </button> */}
                        </Col>
                      </Row>
                    </div>
                  ))}
                  {/* <button type="button" onClick={handleAddInput}>
              Add
            </button> */}
                  <Button
                    type="button"
                    variant="contained"
                    className="primary-filled "
                    onClick={handleAddInput}
                  >
                    Add
                  </Button>
                </div>
              </Stack>
            
          </Modal.Body>
          <Modal.Footer className=''>
            <div className="mx-auto d-flex gap-2" >

              <Button variant="contained" className="primary-gray" onClick={() => setAddTimesheet(false)}>Cancel</Button>
                <Button variant="contained" type='submit' className="primary-filled " disabled={isSubmitting}>Submit</Button>
            </div>

          </Modal.Footer>
        </Form>
      </Modal>

      {/* edit timesheet Details */}
      <Modal show={showEditTimesheet} size="lg" onHide={toggleModalEditTimesheet} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton> 
          <Modal.Title>
            <h5 className='page-title'> Timesheet </h5>
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={formikEdit.handleSubmit}>
          <Modal.Body className="bdr-btm">
            
              <div className="my-card p-4 bg-white">
                <Row>
                  
                  <Col lg="4" md="6" sm="12" className="position-relative">
                    <h6 className="form-lable required-field">
                      Frequency
                    </h6>
                    <Form.Control
                    type="text"
                    name={`timesheet_frequency`}
                    value={formikEdit?.values?.timesheet_frequency}
                    onChange={formikEdit.handleChange}
                    onBlur={formikEdit.handleBlur}
                    id={`timesheet_frequency`}
                    className={
                      formikEdit.errors.timesheet_frequency &&
                      formikEdit.touched.timesheet_frequency
                        ? "input-error"
                        : ""
                    }
                    disabled={true}
                    />
                    
                    {formikEdit.errors.timesheet_frequency &&
                      formikEdit.touched.timesheet_frequency && (
                        <span className="error">
                          {formikEdit.errors.timesheet_frequency}
                        </span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                      <h6 className="form-lable required-field">From Date</h6>
                      <Form.Control
                        type="text"
                        name={`timesheet_from_date`}
                        value={formikEdit?.values?.timesheet_from_date}
                        onChange={formikEdit.handleChange}
                        onBlur={formikEdit.handleBlur}
                        id={`timesheet_from_date`}
                        className={
                          formikEdit.errors.timesheet_from_date &&
                          formikEdit.touched.timesheet_from_date
                            ? "input-error"
                            : ""
                        }
                        disabled={true}
                        />
                      {formikEdit.errors.timesheet_from_date && formikEdit.touched.timesheet_from_date && (
                        <span className="error">{formikEdit.errors.timesheet_from_date}</span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                      <h6 className="form-lable required-field">To Date</h6>
                      <Form.Control
                        type="text"
                        name={`timesheet_to_date`}
                        value={formikEdit?.values?.timesheet_to_date}
                        onChange={formikEdit.handleChange}
                        onBlur={formikEdit.handleBlur}
                        id={`timesheet_to_date`}
                        className={
                          formikEdit.errors.timesheet_to_date &&
                          formikEdit.touched.timesheet_to_date
                            ? "input-error"
                            : ""
                        }
                        disabled={true}
                        />
                      {formikEdit.errors.timesheet_to_date && formikEdit.touched.timesheet_to_date && (
                        <span className="error">{formikEdit.errors.timesheet_to_date}</span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                      <h6 className="form-lable required-field">Pay Type</h6>
                      <Select
                        menuPlacement="auto"
                        options={options_pay_type}
                        name="tut_pay_type"
                        id="tut_pay_type"
                        value={options_pay_type.find(
                          (option) => option.value == formikEdit?.values?.tut_pay_type || ''
                        )}
                        onChange={(selectedOption) => {
                          const event = {
                            target: {
                              name: "tut_pay_type",
                              value: selectedOption["value"],
                            },
                          };
                          formikEdit.handleChange(event);
                          let rate = 0;
                          if(selectedOption["value"] == '1'){
                            rate = tutorData?.tut_flat_rate || 0;
                          }else if(selectedOption["value"] == '2'){
                            rate = tutorData?.tut_per_ses_rate || 0;
                          }else if(selectedOption["value"] == '3'){
                            rate = tutorData?.tut_per_stu_rate || 0;
                          }
                          formikEdit.setFieldValue("timesheet_pay_rate", rate);
                        }}
                        onBlur={(event) => {
                          formikEdit.handleBlur(event);
                          formikEdit.setTouched({ ...formikEdit.touched, tut_pay_type: true });
                        }}
                        className={
                          formikEdit.errors.tut_pay_type && formikEdit.touched.tut_pay_type
                            ? "input-error"
                            : ""
                        }
                      />
                      {formikEdit.errors.tut_pay_type && formikEdit.touched.tut_pay_type && (
                        <span className="error">{formikEdit.errors.tut_pay_type}</span>
                      )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                    <h6 className="form-lable required-field">Pay Rate</h6>
                    <Form.Control
                      type="number"
                      id="timesheet_pay_rate"
                      step="0.01"
                      min="0"          // minimum allowed value
                      value={formikEdit?.values?.timesheet_pay_rate}
                      onChange={formikEdit.handleChange}
                      onBlur={formikEdit.handleBlur}
                      className={
                        formikEdit.errors.timesheet_pay_rate && formikEdit.touched.timesheet_pay_rate
                          ? "input-error"
                          : ""
                      }
                      disabled={true}
                    />
                    {formikEdit.errors.timesheet_pay_rate && formikEdit.touched.timesheet_pay_rate && (
                      <p className="error">{formikEdit.errors.timesheet_pay_rate}</p>
                    )}
                  </Col>
                  <Col lg="4" md="6" sm="12" className="position-relative">
                    <h6 className="form-lable required-field">Adjustment</h6>
                    <Form.Control
                      type="number"
                      id="timesheet_adjustment_amount"
                      step="0.01"
                      min="0"          // minimum allowed value
                      value={formikEdit?.values?.timesheet_adjustment_amount}
                      onChange={formikEdit.handleChange}
                      onBlur={formikEdit.handleBlur}
                      className={
                        formikEdit.errors.timesheet_adjustment_amount && formikEdit.touched.timesheet_adjustment_amount
                          ? "input-error"
                          : ""
                      }
                    />
                    {formikEdit.errors.timesheet_adjustment_amount && formikEdit.touched.timesheet_adjustment_amount && (
                      <p className="error">{formikEdit.errors.timesheet_adjustment_amount}</p>
                    )}
                  </Col>
                  <Col lg="12" md="12" sm="12" className="position-relative">
                    <h6 className="form-lable">Note</h6>
                    
                    <Form.Control as="textarea" rows={3}
                        value={formikEdit?.values?.timesheet_note}
                        onChange={formikEdit.handleChange}
                        onBlur={formikEdit.handleBlur}
                        id="timesheet_note"
                        className={formikEdit.errors.timesheet_note && formikEdit.touched.timesheet_note ? "input-error control_textarea" : "control_textarea mb-0"}
                    />
                    {formikEdit.errors.timesheet_note && formikEdit.touched.timesheet_note && (
                      <p className="error">{formikEdit.errors.timesheet_note}</p>
                    )}
                  </Col>
                   <div className="mt-3">
                    {
                      <h6>
                        Total Amount : 
                        {(calculateTotalAmount(formikEdit.values.tut_pay_type, 
                        formikEdit.values.timesheet_pay_rate, 
                        formikEdit.values.dynamicFields) - formikEdit.values.timesheet_adjustment_amount)}
                      </h6>
                    }
                  </div>
                </Row>
              </div>
            
            {/* session Details */}
              <Stack className="mt-4">
                <div className="my-card p-4 bg-white">
                  <div className="section-heading border-bottom pb-3 mb-3">
                    <h6 className="mb-0">Session Details </h6>
                  </div>

                  {/* Dynamic Fields */}
                  {formikEdit?.values?.dynamicFields.map((field, index) => (
                    <div key={index}>
                      <Row>
                        <Col lg="3" md="6" sm="12" className="position-relative">
                          <h6 className="form-lable required-field">Date</h6>
                          <LocalizationProvider
                            className={"form-control"}
                            dateAdapter={AdapterDayjs}
                          >
                            <DatePicker
                              views={["year", "month", "day"]}
                              value={dayjs(field.session_date, "YYYY-MM-DD")}
                              onChange={(date) => {
                                const event = {
                                  target: {
                                    name: `dynamicFields[${index}].session_date`,
                                    value:
                                      date != null
                                        ? dayjs(date, "YYYY-MM-DD").format(
                                            "YYYY-MM-DD"
                                          )
                                        : date,
                                  },
                                };
                                formikEdit.handleChange(event);
                              }}
                              onBlur={(event) => {
                                formikEdit.handleBlur(event);
                                //formik.setTouched({ ...touched, ls_date: true });
                              }}
                              name={`dynamicFields[${index}].session_date`}
                              slotProps={{
                                textField: {
                                  readOnly: true,
                                  size: "small",
                                  id: `dynamicFields[${index}].session_date`,
                                },
                              }}
                              className={
                                formikEdit.errors.dynamicFields &&
                                formikEdit.errors.dynamicFields[index]?.session_date &&
                                formikEdit.touched.dynamicFields &&
                                formikEdit.touched.dynamicFields[index]?.session_date
                                  ? "input-error w-100"
                                  : "w-100"
                              }
                              minDate={dayjs().subtract(1, 'year')}
                              maxDate={dayjs().add(1, 'year')}
                              format="DD-MM-YYYY"
                            />
                          </LocalizationProvider>
                          {formikEdit.errors.dynamicFields &&
                            formikEdit.errors.dynamicFields[index]?.session_date &&
                            formikEdit.touched.dynamicFields &&
                            formikEdit.touched.dynamicFields[index]?.session_date && (
                              <span className="error">
                                {formikEdit.errors.dynamicFields[index].session_date}
                              </span>
                            )}
                        </Col>
                        <Col lg="5" md="6" sm="12" className='position-relative'>
                          <h6 className="form-lable required-field">Name</h6>
                          <Form.Control
                          type="text"
                          name={`dynamicFields[${index}].session_name`}
                          value={field.session_name}
                          onChange={formikEdit.handleChange}
                          onBlur={formikEdit.handleBlur}
                          id={`dynamicFields[${index}].session_name`}
                          className={formikEdit.errors.dynamicFields && formikEdit.errors.dynamicFields[index]?.session_name && formikEdit.touched.dynamicFields && formikEdit.touched.dynamicFields[index]?.session_name ? "input-error" : ""}
                          />
                          {formikEdit.errors.dynamicFields && formikEdit.errors.dynamicFields[index]?.session_name && formikEdit.touched.dynamicFields && formikEdit.touched.dynamicFields[index]?.session_name && <p className="error">{formikEdit.errors.dynamicFields[index].session_name}</p>}
                        </Col> 
                      
                        <Col lg="3" md="6" sm="12" className="position-relative">
                          <h6 className="form-lable required-field">No Of Student</h6>
                          <Form.Control
                            type="text"
                            name={`dynamicFields[${index}].no_of_student`}
                            value={field.no_of_student}
                            onChange={formikEdit.handleChange}
                            onBlur={formikEdit.handleBlur}
                            id={`dynamicFields[${index}].no_of_student`}
                            className={
                              formikEdit.errors.dynamicFields &&
                              formikEdit.errors.dynamicFields[index]?.no_of_student &&
                              formikEdit.touched.dynamicFields &&
                              formikEdit.touched.dynamicFields[index]?.no_of_student
                                ? "input-error"
                                : ""
                            }
                          />
                          {formikEdit.errors.dynamicFields &&
                            formikEdit.errors.dynamicFields[index]?.no_of_student &&
                            formikEdit.touched.dynamicFields &&
                            formikEdit.touched.dynamicFields[index]?.no_of_student && (
                              <p className="error">
                                {formikEdit.errors.dynamicFields[index].no_of_student}
                              </p>
                            )}
                        </Col>

                        <Col
                          lg="1"
                          md="1"
                          sm="1"
                          className="position-relative mt-4"
                        >
                          <Button
                            type="button"
                            variant="outlined-red"
                            className="filled-danger my-2"
                            style={{
                              display:
                                formikEdit.values.dynamicFields.length == 1
                                  ? "none"
                                  : "block",
                            }}
                            onClick={() => handleRemoveInputEdit(index)}
                          >
                            Delete
                          </Button>

                          {/* <button type="button" onClick={() => handleRemoveInput(index)}>
                        Remove
                        </button> */}
                        </Col>
                      </Row>
                    </div>
                  ))}
                  {/* <button type="button" onClick={handleAddInput}>
              Add
            </button> */}
                  <Button
                    type="button"
                    variant="contained"
                    className="primary-filled "
                    onClick={handleAddInputEdit}
                  >
                    Add
                  </Button>
                </div>
              </Stack>
            
          </Modal.Body>
          <Modal.Footer className=''>
            <div className="mx-auto d-flex gap-2" >

              <Button variant="contained" className="primary-gray" onClick={() => setEditTimesheet(false)}>Cancel</Button>
                <Button variant="contained" type='submit' className="primary-filled " disabled={isEditSubmitting}>Submit</Button>
            </div>

          </Modal.Footer>
        </Form>
      </Modal>
      {/* --------------Page Start--------------- */}


      {/* --------------Section Start--------------- */}

      <div className="mb-3 d-flex justify-content-between align-items-center">
        <div>
          <h5 className='page-title'> Tutor Payment</h5>

          <div role="presentation" >
            <Breadcrumbs aria-label="breadcrumb" className='my-breadcrumbs'>
              <NavLink underline="hover" color="inherit" to='/calendar'> Home</NavLink>



              <Typography color="text.primary">Tutor Payment</Typography>
            </Breadcrumbs>
          </div>
        </div>
        <div>
          <div className='d-flex align-items-center gap-2'>
            {/*<div>
                            <Button className="secondary-filled " variant="contained" onClick={() => navigate(window.history.back())}>
                                Back
                             </Button>
                         </div>*/}
                        

              <div >
                  <DropdownButton as={ButtonGroup} title="Action" id="dropdown-menu-align-responsive-1" className="ps-0 rounded-10 primary-filled btn-action text-light">
                      <Dropdown.Item onClick={() => handleTutorClick()}>  Edit Tutor
                      </Dropdown.Item>


                  </DropdownButton>
              </div>
            {/* <NavLink className="primary-filled rounded-10 p-2" to=''>
              <AddIcon className="btn-icon" />View Payments</NavLink> */}

          </div>
        </div>
      </div>
      <Card className='my-card p-1 bg-white'>

        <Card.Body>
          <Stack gap={3} >
                <div className="mb-3">

                </div>
          </Stack>
          <Stack gap={3} >
                <div className="mb-3">

                    <div className="cus-les-sec">
                        
                        <div className='cus-les-right w-100 d-flex justify-content-between' >
                            <div className="cus-les-rst">
                              <span className='ml-5 mt-4'><h5>{tutorData ? tutorData.tut_fname != null && tutorData.tut_fname != '' ? tutorData.tut_fname + ' ' + tutorData.tut_surname  : '' : ''}</h5></span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <Form.Select
                                size="sm"
                                style={{ width: '170px' }}
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                                aria-label="Filter by month"
                              >
                                <option value="">All months</option>
                                {monthOptions.map((m) => (
                                  <option key={m.value} value={m.value}>{m.label}</option>
                                ))}
                              </Form.Select>
                              <Button variant="outlined-red" onClick={() => setShowPrintModal(true)} className="primary-blue my-2">
                                Print PDF
                              </Button>
                              <PrintTimesheetModal
                                show={showPrintModal}
                                onHide={() => setShowPrintModal(false)}
                                defaultTutorKey={Id || ''}
                                defaultMonth={selectedMonth}
                              />
                              <Button variant="outlined-red" onClick={() => {
                                setAddTimesheet(true);
                                setSessionDetails([
                                  {
                                    session_key: "",
                                    session_name: "",
                                    session_date: "",
                                    no_of_student: "0"
                                  }
                                ]);
                                formik.setFieldValue("tut_pay_type", tutorData.tut_pay_type || "");
                                }} 
                              className="primary-blue my-2" >Create Timesheet</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Stack>
          {/* -------------Content Start--------------- */}

          <Row>
            <Col xs="12">
              <div className="">
                <div>
                  <p className="text-black d-flex mb-2"style={{fontSize: '11px'}}> 
                    *<span style={{fontSize: '11px'}}> An automated job runs daily at midnight to validate the tutor’s start date or the last generated payslip date, and then generates tutor timesheets and payslips accordingly.</span>
                  </p>
                </div>
                <Row className="justify-content-center">
                        
                



                  {/* --------------Table Content Start--------------- */}
                  <Col sm={12}>

                    <Box
                      sx={{
                        height: "fit-content",
                        width: "100%",
                        "& .actions": {
                          color: "text.secondary",
                        },
                        "& .textPrimary": {
                          color: "text.primary",
                        },
                        "& .super-app-theme--header": {
                          backgroundColor: "#f4f4f4",
                        },
                      }}
                      style={{ height: '100%', width: "100%" }}
                    >
                     <DataGrid
                        sx={{
                          // disable cell selection style
                          '.MuiDataGrid-cell:focus': {
                            outline: 'none'
                          },
                          // pointer cursor on ALL rows
                          '& .MuiDataGrid-row:hover': {
                            cursor: 'pointer'
                          }
                        }}
                        autoHeight
                        slots={{
                          loadingOverlay: LinearProgress,
                          //noRowsOverlay: CustomNoRowsOverlay,
                          toolbar: GridToolbar,
                          // toolbar: EditToolbar,
                        }}
                        slotProps={{
                          toolbar: {
                            csvOptions: { fileName: "TutorPayment" },
                            printOptions: { pageStyle: `@media print {
                                      @page {
                                        size: A4 landscape;
                                        margin: 0;
                                      }
                                    }`, disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "TutorPayment" },
                            records,
                            showQuickFilter: true
                          },


                        }}
                        initialState={{
                          ...records.initialState,
                          pagination: { paginationModel: { pageSize: 10 } },
                        }}
                        showQuickFilter={true}

                        pageSizeOptions={[10, 25, 50, 100]}

                        loading={loading}
                        rows={visibleRecords.map((row, index) => ({ ...row, id: `${index+1}` }))}
                        columns={columns}
                        rowHeight={60} density="standard"
                        disableRowSelectionOnClick
                        showCellVerticalBorder= {true}
                        showColumnVerticalBorder= {true}
                      //  onRowClick={(params) => handleRowClick(params.row)}


                      />
                    </Box>



                  </Col>
                  {/* --------------Table Content Start--------------- */}

                </Row>

              </div>
            </Col>
          </Row>

          {/* --------------Content End--------------- */}


        </Card.Body>

      </Card>

      {/* --------------Section End--------------- */}




      {/* --------------Page End--------------- */}

    </div>

    </>
  );
}

export default ListTutorTimeSheet;